export default "__VITE_ASSET__5a64232a__"